import api from '@/api'
import lodash from 'lodash'

export default {
  namespaced: true,
  state: {
    data: {},
    lineSortFunc: (a, b) => lodash.last(a.informations.Factory) === lodash.last(b.informations.Factory) ? (parseInt(lodash.last(a.informations.Index) || 99) > parseInt(lodash.last(b.informations.Index) || 99) ? 1 : -1) : (lodash.last(a.informations.Factory) > lodash.last(b.informations.Factory) ? 1 : -1)
  },
  actions: {
    async load (context) {
      const res = await api.getBIZ(`/api/content?uri=settings`)
      context.state.data = res.data
      const resLine = await api.postBIZ('/api/content/find', {selector: {entity: 'equipment_ledger', type: 'line'}, fields: ['title', 'informations.Factory', 'informations.Index'], limit: 9999})
      context.state.data.lines = ['All'].concat(resLine.data.sort(context.state.lineSortFunc).map(e => e.title))
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/settings.js